import(/* webpackMode: "eager" */ "/builds/devteam/iconosquare/icofrontend/src/app/(dashboard)/dashboard/overview/page.tsx");
